// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen{div.footer[data-v-39b68e34]{display:none}}@media print{div.footer[data-v-39b68e34]{border-top:2px solid #f47ba9;margin-top:10px;position:fixed;bottom:0}div.footer p[data-v-39b68e34]{text-align:center}}table[data-v-39b68e34]{border-collapse:collapse}thead[data-v-39b68e34]{display:table-row-group}tr td[data-v-39b68e34]{page-break-inside:avoid}.no-border[data-v-39b68e34]{border:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
